module.exports = __webpack_public_path__ + "static/media/registration.0ea19c4e.png";